import { ContentTypeEnum } from 'Types/content/content.types'

import { CaseItemType } from 'Portal/__generated__/globalTypes'

export const organisationDashboardMockStatisticData = [
  {
    contentType: ContentTypeEnum.rentals,
    count: 100,
    data: [100, 120, 150, 130],
    labels: ['Nov', 'Dec', 'Jan', 'Feb'],
    progress: -20,
  },
  {
    contentType: ContentTypeEnum.phone_plans,
    count: 10,
    data: [80, 90, 100, 110],
    labels: ['Nov', 'Dec', 'Jan', 'Feb'],
    progress: 10,
  },
  {
    contentType: ContentTypeEnum.employees,
    count: 80,
    data: [100, 140, 150, 150],
    labels: ['Nov', 'Dec', 'Jan', 'Feb'],
    progress: 0,
  },
  {
    contentType: ContentTypeEnum.caseitems,
    count: 120,
    data: [100, 120, 100, 90],
    labels: ['Nov', 'Dec', 'Jan', 'Feb'],
    progress: -10,
  },
  {
    contentType: ContentTypeEnum.depots,
    count: 2,
    data: [13, 1, 1, 2],
    labels: ['Nov', 'Dec', 'Jan', 'Feb'],
    progress: 50,
  },
]

export const organisationDashboardMockEarlyUpgradeEligibleData = {
  count: 87,
  data: [13, 24, 50],
  labels: ['Mar', 'Apr', 'May'],
}

export const organisationDashboardMockDeviceCountData = [
  { count: 1708, name: 'iPhone 11 128GB' },
  { count: 1620, name: 'iPad 8th Gen. 128GB' },
  { count: 1150, name: 'iPad Pro 11 (2018) 256GB' },
  { count: 710, name: 'iPhone SE 128GB' },
  { count: 260, name: 'iPhone 12 Pro 128GB' },
  { count: 100, name: 'iPhone SE (2020) 128GB' },
  { count: 60, name: 'iPad Pro 128GB' },
  { count: 40, name: 'Pencil' },
  { count: 20, name: 'Pencil 2' },
  { count: 10, name: 'Others' },
]

export const organisationDashboardMockOrderCountData = [
  {
    data: [10, 8, 9, 7, 10, 8, 9, 7, 10, 8, 9, 7],
    type: CaseItemType.new_device,
  },
  {
    data: [10, 18, 22, 20, 7, 17, 9, 30, 32, 20, 24, 29],
    type: CaseItemType.upgrade_device,
  },
  {
    data: [12, 10, 11, 9, 12, 10, 11, 9, 12, 10, 11, 9],
    type: CaseItemType.early_upgrade_device,
  },
  {
    data: [1, 8, 9, 7, 1, 8, 9, 3, 4, 4, 7, 5],
    type: CaseItemType.lost_device,
  },
  {
    data: [1, 3, 2, 4, 3, 2, 4, 3, 4, 4, 2, 1],
    type: CaseItemType.repair_device,
  },
  {
    data: [0, 1, 2, 0, 0, 3, 0, 1, 5, 0, 3, 2],
    type: CaseItemType.cancel_device,
  },
]

export const organisationDashboardMockOrderCountLabels = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]
